import defaultLayoutComponent from '~pages/nrw/layouts/NrwDefaultLayoutComponents.js'
// import NrwSingleLayoutComponents from '~pages/nrw/layouts/NrwSingleLayoutComponents.js'

let routeInfo = [
  {
    path: 'promo/:promoId',
    name: 'Promotion',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_promotion" */'~pages/nrw/promo/Promotion.vue') }
    ),
    beforeEnter: (to, from, next) => {
      next({ name: 'PromotionMain', params: { promoId: to.params.promoId }, hash: to.hash })
    },
    meta: {
      authorized: false
    }
  },
  {
    path: ':promoId',
    name: 'PromotionMain',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_promotion" */'~pages/nrw/promo/Promotion.vue') }
    ),
    meta: {
      authorized: false
    }
  },
  {
    path: ':promoId/promoDetail/:subHtml',
    name: 'PromoDetail',
    beforeEnter: (to, from, next) => {
      if (_.isEmpty(to.params.subHtml)) {
        next({name: 'index'})
      } else {
        next()
      }
    },
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_promotion" */'~pages/nrw/promo/PromotionDetail.vue') }
    ),
    meta: {
      authorized: false,
      wrapClass: 'promotion_sub'
    }
  }
]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/nrw/child/promoRouter.js